import { Typography } from '@stardust-ds/react'
import { FormProvider, useForm } from "react-hook-form"
import styles from './index.module.scss'
import FileInput from '../../atoms/FileInput'
import RcmpFormField from '../../organisms/FormField'
import Button from '../../atoms/Button'
import intl from "react-intl-universal"
import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import FileCard from '../../atoms/FileCard'
import { fnCreateActivityByForm, fnListFieldsFromForm } from '../../../services/forms'
import useDataApi from '../../../hooks/useDataApi'
import { useParams } from 'react-router'
import RcmpLoading from '../../atoms/Loading'
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import { fnFormatDateToUTC } from '../../../utils/date'
import { Turnstile } from '@marsidev/react-turnstile'
import RcmpAlertIcon from '../../../assets/icons/AlertIcon'
import moment, { fn } from 'moment'
import RcmpFormErrorMessage from '../../atoms/FormErrorMessage'
import { BrandImage, BrandTitle, useAppearanceContext } from '../../../contexts/Appearance'

function fnCreateFieldsValitionSchema(aFields) {
    if (!aFields?.length) return

    const fieldsValidations = {}

    aFields.forEach((field) => {
        const cFieldName = `activity-field-${field.field_id}`

        if (field?.type?.toLowerCase() === "selection") {
            fieldsValidations[cFieldName] = field.required
                ? yup.mixed().required(intl.get("form.required_field"))
                : yup.mixed().nullable()
            return
        }

        if (field?.type?.toLowerCase() === "date") {
            fieldsValidations[cFieldName] =
                field.required ?
                    yup.date()
                        .transform((curr, orig) => {
                            if (!orig || orig?.length == 0) {
                                return null
                            } else {
                                return new Date(
                                    fnFormatDateToUTC(
                                        orig,
                                        "America/Sao_Paulo",
                                        "YYYY-MM-DD[T]HH:mm:ss.SSS"
                                    )
                                )
                            }
                        })
                        .required(intl.get("form.required_field"))
                        .typeError(intl.get("form.invalid_date"))
                    : yup
                        .date()
                        .nullable()
                        .transform((curr, orig) => {
                            if (!orig || orig?.length == 0) {
                                return null
                            } else {
                                return new Date(
                                    fnFormatDateToUTC(
                                        orig,
                                        "America/Sao_Paulo",
                                        "YYYY-MM-DD[T]HH:mm:ss.SSS"
                                    )
                                )
                            }
                        })
                        .typeError(intl.get("form.invalid_date"))
            return
        }

        fieldsValidations[cFieldName] = field.required
            ? yup.string().required(intl.get("form.required_field"))
            : yup.string()
    })

    return yup.object().shape(fieldsValidations)
}

export default function ActivityForm() {
    const [aFiles, fnSetAFiles] = useState([])
    const [bSentForm, fnSetSBSentForm] = useState(false)
    const [oFormData, fnSetFormData] = useState({})
    const [cCaptcha, fnSetCChaptcha] = useState("")
    const [bisInactiveForm, fnSetBIsInactiveForm] = useState(false)

    const [oListFieldsFromFormRes, fnListFieldsFromFormReq] = useDataApi(fnListFieldsFromForm)
    const [oCreateFormRes, fnCreateFromFormReq] = useDataApi(fnCreateActivityByForm)

    const { idForm, id } = useParams()

    const { getTurnstileKey } = useAppearanceContext()
    const cCaptchaKey = getTurnstileKey()

    const aVisibleFields = oFormData?.fields?.filter((field) => field?.isVisible)?.sort((a, b) => a?.position - b?.position) || []

    const useFormMethods = useForm({
        resolver: aVisibleFields?.length > 0 ? yupResolver(fnCreateFieldsValitionSchema(aVisibleFields)) : undefined
    })

    const {
        handleSubmit,
        reset,
        getValues,
        setValue,
        clearErrors,
        formState: { errors },
        setError
    } = useFormMethods

    const captchRef = useRef(null)

    const schema = yup.object().shape({
        formId: yup.number().required(),
        evidences: yup.array().of(yup.object().shape({
            filename: yup.string(),
            value: yup.string().required()
        })),
        token: yup.string().required(intl.get("form.required_field")),
    })
    useLayoutEffect(() => {
        if (bSentForm) return
        const response = captchRef.current?.getResponse()
        fnSetCChaptcha(response)
    }, [bSentForm])
    useLayoutEffect(() => {
        (async () => {
            const response = await fnListFieldsFromFormReq(id, idForm)
            if (response?.data?.isActive) {
                fnSetFormData(response?.data)
                return
            }
            fnSetBIsInactiveForm(true)
            return
        })()
    }, [])

    function fnSubmitFileEvidence(data) {
        if (!data[0]) return
        let filesToSend = data.map(d => {
            return d
        })
        if (aFiles.length === 0) {
            fnSetAFiles(data)
            filesToSend = []
            return
        }
        fnSetAFiles(prev => prev.concat(data));
        filesToSend = []
        return
    }

    function RcmpConfirmSendForm() {
        return (
            <div className={styles.textConfirmationContainer} style={{ marginTop: oFormData?.customer?.logo ? 32 : 0 }}>
                <Typography type='h2' textAlign='left' color='#415364'>{intl.get("view_form.sent_form")}</Typography>
            </div>
        )
    }

    function fnDeleteEvidence(index) {
        const temp = [...aFiles]
        temp.splice(index, 1)
        fnSetAFiles(temp)

    }

    if (oListFieldsFromFormRes.loading) return (
        <div className={styles.activityLoadingContainer}>
            <div className={styles.loadingContainer}>
                <RcmpLoading bShow={true} />

            </div>
        </div>
    )
    function fnHanleOnSuccessCaptha(token) {
        fnSetCChaptcha(token)
        setValue("token", token)

    }



    function fnHanleOnErrorCaptha() {
        fnSetCChaptcha(null)
    }
    async function fnSendForm() {
        let formatedPayload = {}
        if (!getValues("token") || getValues("token") === "" || !cCaptcha) {
            return setError("token", { type: "manual", message: intl.get("form.required_field") })
        }
        const formatedFieldsValue = aVisibleFields.map((field, i) => {
            if (field.type === 'SELECTION') {
                return {
                    slug: field.slug,
                    optionId: getValues(`activity-field-${field.field_id}`) || null,
                }
            }
            if (field.type === 'DATE') {
                const dDateValue = getValues(`activity-field-${field.field_id}`);
                if (!dDateValue.length) {
                    return {
                        slug: field.slug,
                        value: getValues(`activity-field-${field.field_id}`)
                    }
                }
                const dDate = new Date(dDateValue);
                dDate.setHours(dDate.getHours() + 3);
                const dDataFormated = dDate.toISOString();

                return {
                    slug: field.slug,
                    value: dDataFormated
                }
            }
            return {
                slug: field.slug,
                value: getValues(`activity-field-${field.field_id}`) || "",
            }
        })
        setValue("formId", parseInt(idForm))
        setValue("fields", formatedFieldsValue)

        formatedPayload = {
            fields: formatedFieldsValue,
            formId: parseInt(idForm),
            "cf-turnstile-response": cCaptcha
        }
        if (oFormData.evidenceUpload && aFiles.length > 0) {
            let files = aFiles.map((file) => {
                return {
                    filename: file.opae_cfilename,
                    value: file.opae_cvalue
                }
            })
            const oPayload = formatedPayload
            setValue("evidences", files)
            formatedPayload = {
                ...oPayload,
                evidences: [...files],
            }
        }

        try {

            await schema.validate(getValues(), { abortEarly: false })
            const response = await fnCreateFromFormReq(id, formatedPayload)
            if (response?.response?.status === 406 && response.name === "AxiosError") {
                fnSetBIsInactiveForm(true)
                return
            }
            fnSetSBSentForm(true)
            fnSetAFiles([])
            fnSetCChaptcha("")
            reset({})
        } catch (error) {
            console.log("error", error)
        }
    }


    function fnHandleSendFormAgain(e) {

        e.preventDefault()
        e.stopPropagation()
        clearErrors()
        fnSetSBSentForm(false)
    }
    if (bisInactiveForm) {
        return (
            <div className={styles.activityFormContainerInactive}>
                <div className={styles.activityFormContentInactive}>
                    <div className={styles.innactiveContainerText}>
                        <div className={styles.imageContainer}>
                            <RcmpAlertIcon />
                        </div>
                        <Typography color='#415364' textAlign='center'>{intl.get("form.inactive_form")}</Typography>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <FormProvider {...useFormMethods}>
            <div className={styles.activityFormContainer}>
                <form id="newFormActivity" onSubmit={handleSubmit(fnSendForm)}>
                    <div className={styles.activityFormContent} style={{ height: bSentForm ? "max-content" : "" }}>
                        <div className={styles.imageContainer}>
                            {oFormData?.customer?.logo
                                ? <img src={oFormData.customer.logo} />
                                : <BrandImage cFileName="logo-text-2084x2084.jpg" />
                            }
                        </div>
                        {!bSentForm && (
                            <div className={styles.titleContainer}>
                                <Typography type='h2' textAlign='left' color='#415364'>{oFormData?.formName}</Typography>
                                <Typography type='p2' textAlign='left' color='#415364'>{oFormData?.formDescription}</Typography>
                            </div>
                        )}

                        {!bSentForm && !bisInactiveForm ? <div className={styles.fieldsContainer}>
                            {
                                aVisibleFields?.map((field, i) => {
                                    return (
                                        <RcmpFormField
                                            key={i}
                                            {...field}
                                            name={field?.name}
                                            autofill={false}
                                            slug={field.slug}
                                            type={field.type}
                                            id={field.field_id}
                                            bIsDisabled={false}
                                            bIsEditModel={true}
                                            isForm={true}

                                        />
                                    )
                                })
                            }
                            {oFormData.evidenceUpload &&
                                <div className={styles.uploadFiles}>
                                    <Typography type='l3' color='#415364'>
                                        {intl.get("view_form.upload_files")}
                                    </Typography>
                                    <FileInput bIsAuthenticated={false} fnFileSubmit={fnSubmitFileEvidence} />
                                    {aFiles.map((file, i) => (
                                        <FileCard isForm={true} key={i} title={file?.opae_cfilename} removeFile={() => fnDeleteEvidence(i)} />
                                    ))}
                                </div>
                            }
                            <Turnstile
                                siteKey={cCaptchaKey}
                                onSuccess={fnHanleOnSuccessCaptha}
                                onError={fnHanleOnErrorCaptha}
                                refreshExpired="manual"
                                ref={captchRef}
                            />
                            <RcmpFormErrorMessage>
                                {errors?.token?.message}
                            </RcmpFormErrorMessage>
                            <div className={styles.mobileFooter}>
                                {!bSentForm ? <Button form="newFormActivity" disabled={process.env.ENVIROMENT === "local" && !cCaptcha} type="submit">{intl.get("view_form.send")}</Button>
                                    :
                                    <Button >{intl.get("view_form.reply_again")}</Button>
                                }
                                <Typography textAlign='left' type='p2' color='#415364'>Powered by <BrandTitle /></Typography>
                            </div>
                        </div> :
                            (
                                <>
                                    {RcmpConfirmSendForm()}
                                    <div className={styles.sentFormmobileFooter}>
                                        <Button onClick={fnHandleSendFormAgain} type="button">{intl.get("view_form.reply_again")}</Button>
                                    </div>
                                </>
                            )
                        }
                    </div>
                    <div className={styles.poweredText}>
                        <Typography textAlign='left' type='p2' color='#415364'>Powered by <BrandTitle /></Typography>
                        {!bSentForm ? <Button form="newFormActivity" type="submit" disabled={process.env.ENVIROMENT === "local" && !cCaptcha} isLoading={oCreateFormRes.loading}>{intl.get("view_form.send")}</Button>
                            :
                            <Button onClick={fnHandleSendFormAgain} type="button">
                                {intl.get("view_form.reply_again")}
                            </Button>
                        }
                    </div>
                </form>
            </div>
        </FormProvider>
    )
}